import React from "react";
import "../css/ReviewStep.css";

const Field = ({ label, value }) => (
  <div className="review-field">
    <span className="review-field-label">{label}</span>
    <span className="review-field-value">
      {value || <span className="review-field-empty">—</span>}
    </span>
  </div>
);

const ReviewStep = ({ formData, goToStep }) => {
  const {
    site_information = {},
    domain_detail = {},
    admin_user = {},
  } = formData;
  console.log(formData)
  return (
    <div className="review-container">
      {/* Left — Site Information */}
      <div className="review-panel review-panel-left">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h6 className="review-panel-title">Site Information</h6>
          <span
            className="edit-button"
            onClick={() => {
              goToStep(1);
            }}
          >
            edit
          </span>
        </div>
        <Field label="Site Name" value={formData.site_information.company_name} />
        <Field label="Address" value={site_information.address} />
        <Field label="City" value={site_information.city} />
        <Field label="Country" value={site_information.country} />
        <Field label="Postal Code" value={site_information.postal_code} />
      </div>

      {/* Right — stacked */}
      <div className="review-panel-right">
        <div className="review-panel review-panel-top">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h6 className="review-panel-title">Domain Information</h6>
            <span
              className="edit-button"
              onClick={() => {
                goToStep(2);
              }}
            >
              edit
            </span>
          </div>
          <Field label="Domain Name" value={domain_detail.domain_name} />
          <Field
            label="Modules"
            value={
              domain_detail.modules?.length
                ? domain_detail.modules.join(", ")
                : null
            }
          />
        </div>

        <div className="review-panel review-panel-bottom">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h6 className="review-panel-title">Admin User</h6>
            <span
              className="edit-button"
              onClick={() => {
                goToStep(3);
              }}
            >
              edit
            </span>
          </div>
          {admin_user.new_user ? (
            <>
              <Field label="First Name" value={admin_user.first_name} />
              <Field label="Last Name" value={admin_user.last_name} />
              <Field label="Email" value={admin_user.email} />
              <Field label="Phone" value={admin_user.phone} />
              <Field
                label="Modules"
                value={
                  admin_user.modules?.length
                    ? admin_user.modules.join(", ")
                    : null
                }
              />
            </>
          ) : (
            <span className="review-field-empty">
              No new user will be created.
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReviewStep;
